import { useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/** Scroll to the top on every page change; keep position on browser back/forward and #anchor links. */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
  }, []);
  useLayoutEffect(() => {
    if (hash || navType === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.querySelectorAll('[data-scroll-container], main').forEach((el) => { el.scrollTop = 0; });
  }, [pathname, hash, navType]);
  return null;
}
